<template>
  <div>
    <modal-image-viewer
      :id="custome_id"
      :image-list="previewImage"
      :selected_file="selected_file"
    ></modal-image-viewer>

    <div class="full-input-group">
      <b-form-group
        :label="`${title ? title : '上傳文件'}：`"
        label-class="full-label"
        label-for="upload"
        :class="required ? 'required' : ''"
      >
        <div id="file-drag-drop">
          <div class="fileform" :ref="`fileform${custome_id}`">
            <div
              v-show="!previewImage > 0 || previewImage.length == 0"
              class="mt-2 pt-50"
            >
              <font-awesome-icon icon="fa-solid fa-cloud-arrow-up" />
              <p class="colorBlack mt-1 mb-50">選擇檔案或將檔案拖放於此</p>
              <p class="mb-50">只能選擇PDF檔或圖片類型的檔案</p>
              <p class="mb-50">Each file size no more than 10MB</p>
              <p class="mb-2">每次最多上傳 {{ maxFiles }} 個檔案</p>
              <a
                href="javascript:void(0)"
                class="file-button bgColor1"
                @click="handleUpload"
                >選擇檔案</a
              >
              <b-button
                v-if="isMobile"
                @click="handleUpload(true)"
                class="ml-1 round-100 bgColor1 p-50"
              >
                <feather-icon icon="CameraIcon" size="16" />
              </b-button>

              <b-form-file
                v-model="image_files"
                style="display: none"
                @input="getImagePreviews"
                :ref="`pickFile${custome_id}`"
                multiple
                :capture="capture_check"
                :max-files="limit_files"
                placeholder="選擇檔案或將檔案拖放於此"
                drop-placeholder="將檔案拖放於此"
              ></b-form-file>
            </div>
            <div
              class="file-listing"
              v-show="previewImage && previewImage.length > 0"
            >

              <a
                href="javascript:void(0)"
                class="removeAllButton d-flex align-items-center"
                @click="removeAll()"
                >
                <feather-icon size="18" class="mr-25" icon="Trash2Icon" />
                按此取消全部新添加的檔案</a
              >
              <!-- <p class="mb-50">只能選擇PDF檔或圖片類型的檔案</p> -->
              <div
                class="d-flex justify-content-center mb-2 align-items-center"
              >
                <h4 class="mb-0 color1">
                  新增檔案（{{ image_files_all.length }} / {{ maxFiles }}）
                </h4>
                <b-button
                  v-if="image_files_all.length < maxFiles"
                  @click="
                    $refs[`pickFile${custome_id}`].$el.childNodes[0].click()
                  "
                  class="ml-1 round-100 bgColor1 p-50"
                >
                  <feather-icon icon="PlusIcon" size="16" />
                </b-button>
              </div>
              <!--// if image uploaded show -->

              <div class="preview-list">
                <div
                  class="d-flex preview-list-item justify-content-center align-items-center mb-1"
                  v-for="(file, index) in previewImage"
                  :key="`file-listing${index}`"
                >
                  <div
                    :class="`${
                      file.is_exist ? 'exist-item' : ''
                    } d-flex justify-content-between align-items-center`"
                  >
                    <div class="preview-img-wrapper">
                      <embed
                        v-if="file.type == 'application/pdf'"
                        :src="file.src"
                        class="pdf"
                        type="application/pdf"
                        @error="handlePdfError(file)"
                      />
                      <img
                        v-else
                        class="preview mr-1"
                        :src="file.src"
                        @error="handleImageError(file)"
                        @load="handleImageLoad(file)"
                      />
                    </div>
                    <!-- <span class="text">{{ file.name }}。</span> -->
                    <div class="d-flex">
                      <a
                        class="color1 mr-2 text-nowrap"
                        href="javascript:void(0)"
                        @click="downloadFile(file)"
                        >下載</a
                      >
                      <a
                        class="color1 text-nowrap"
                        href="javascript:void(0)"
                        @click="beforeSubmitPreview(index)"
                        >預覽</a
                      >

                      <a v-if="file_delete_url"
                        class="remove ml-2"
                        v-on:click="removeFile(index, file)"
                      >
                        <feather-icon size="18" class="" icon="Trash2Icon" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="redColor mt-50" v-if="required && previewImage.length == 0">
          請上傳付費文件！
        </p>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BButton,
  BFormFile,
  BOverlay,
} from "bootstrap-vue";
import { ref, watch } from "@vue/composition-api";
import draggable from "vuedraggable";
import ModalImageViewer from "@/layouts/components/file/ModalImageViewer.vue";
import axiosIns from '@/libs/axios';
// import ModalPdf from "@/layouts/components/file/ModalPdf.vue-bak";

/** 單一檔案大小上限（10MB，對齊伺服器 upload_max_filesize = 10M） */
const MAX_FILE_SIZE = 10 * 1024 * 1024;
/** 單次提交可上傳的檔案數上限，避免整個 request 超出 post_max_size 被 PHP 丟棄 */
const DEFAULT_MAX_FILES = 5;
const WORD_MIME =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
const EXCEL_MIMES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormGroup,
    BFormFile,
    draggable,
    BOverlay,
    // ModalPdf,
    ModalImageViewer,
  },
  data() {
    return {
      image_files: [],
      image_files_all: [],
      dragAndDropCapable: false,
      selected_file: null,
      capture_check: false,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    props_previewImage: {
      type: Array,
    },
    custome_id: {
      type: String,
    },
    limit_files: {
      type: Number,
      default: DEFAULT_MAX_FILES,
    },
    required: {
      type: Boolean,
    },
    file_delete_url:{}
  },
  methods: {
    handleUpload(capture = false) {
      if (capture) {
        this.capture_check = true;
      } else {
        this.capture_check = false;
      }
      this.$refs[`pickFile${this.custome_id}`].$el.childNodes[0].click();
    },
    determineDragAndDrop() {
      var div = document.createElement("div");
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },
    /** 檔案大小上限（10MB），與後端 upload_max_filesize 對齊 */
    isOverSize(file) {
      return file.size >= MAX_FILE_SIZE;
    },
    /** 依 MIME / 副檔名決定預覽來源（含 iPhone 的 HEIC/HEIF） */
    resolvePreviewSrc(file) {
      const type = (file.type || "").toLowerCase();
      const name = (file.name || "").toLowerCase();
      const isImage =
        type.indexOf("image/") === 0 ||
        /\.(jpe?g|png|gif|webp|svg|heic|heif)$/.test(name);
      const isPdf = type === "application/pdf" || /\.pdf$/.test(name);

      if (isImage || isPdf) {
        // 用 objectURL 取代 FileReader.readAsDataURL：
        // 同步、不佔記憶體，iOS Safari 一次選多張大相片時不會靜默失敗。
        try {
          return { src: URL.createObjectURL(file), isBlob: true };
        } catch (e) {
          console.error("建立預覽失敗:", file.name, e);
        }
      }
      if (type === WORD_MIME) {
        return { src: process.env.VUE_APP_IMAGE_URL + "/images/icon/word.png", isBlob: false };
      }
      if (EXCEL_MIMES.indexOf(type) > -1) {
        return { src: process.env.VUE_APP_IMAGE_URL + "/images/icon/excel.png", isBlob: false };
      }
      return { src: process.env.VUE_APP_IMAGE_URL + "/images/icon/others.jpeg", isBlob: false };
    },
    /**
     * 由 b-form-file / drag-drop 觸發。
     * 全同步處理：先過濾超size檔案，再逐一建立預覽，最後只 emit 一次。
     * （舊版在 forEach 內對 image_files splice，又用 index === image_files.length - 1
     *   判斷收尾，只要有任何一個檔案被剔除就永遠不會 emit，
     *   父層拿不到檔案，結果是「提交成功但一張圖都沒有」。）
     */
    getImagePreviews() {
      const picked = Array.from(this.image_files || []);
      if (picked.length === 0) return;

      let accepted = [];
      const rejected = [];

      picked.forEach((file) => {
        if (this.isOverSize(file)) {
          rejected.push(file.name || "未命名檔案");
        } else {
          accepted.push(file);
        }
      });

      if (rejected.length > 0) {
        this.$bvToast.toast(
          `以下檔案超過 10MB，未被加入：${rejected.join("、")}`,
          { title: "檔案過大", autoHideDelay: 5000, variant: "danger" }
        );
      }

      // 單次提交的檔案數上限。超過的部分不加入，並明確告知使用者，
      // 避免整個 request 撐爆 post_max_size / max_file_uploads 被 PHP 靜默丟棄。
      const remaining = this.maxFiles - this.image_files_all.length;
      if (remaining <= 0) {
        this.$bvToast.toast(
          `每次最多上傳 ${this.maxFiles} 個檔案，請先提交後再上傳其餘檔案。`,
          { title: "已達上限", autoHideDelay: 5000, variant: "warning" }
        );
        this.image_files = [];
        return;
      }

      let overLimit = [];
      if (accepted.length > remaining) {
        overLimit = accepted.slice(remaining).map((f) => f.name || "未命名檔案");
        accepted = accepted.slice(0, remaining);
      }

      if (overLimit.length > 0) {
        this.$bvToast.toast(
          `每次最多上傳 ${this.maxFiles} 個檔案，以下未被加入：${overLimit.join("、")}`,
          { title: "超出數量上限", autoHideDelay: 5000, variant: "warning" }
        );
      }

      // 只保留通過檢查的檔案，避免下次再重複處理已被拒絕的項目
      this.image_files = accepted;

      accepted.forEach((file) => {
        const preview = this.resolvePreviewSrc(file);
        this.previewImage.push({
          id: null,
          src: preview.src,
          type: file.type,
          name: file.name,
          is_exist: 0,
          blobURL: preview.isBlob ? preview.src : null,
          rawFile: file,
        });
        this.image_files_all.push(file);
      });

      // emit 副本，父層不會與本元件共用同一個陣列參考
      this.$emit("file-uploaded", this.image_files_all.slice());
    },
    removeAll() {
      this.previewImage
        .filter((ele) => !ele.is_exist && ele.blobURL)
        .forEach((ele) => URL.revokeObjectURL(ele.blobURL));

      this.image_files = [];
      this.image_files_all = [];
      this.previewImage = this.previewImage.filter((ele) => ele.is_exist);
      this.$emit("file-uploaded", []);
    },
    removeFile(index, file) {
      if (file.is_exist) {
        this.deleteDocument(file.id);
        return;
      }

      if (file.blobURL) {
        URL.revokeObjectURL(file.blobURL);
      }

      // 以 File 物件本身定位，避免用 index 換算而刪錯檔案
      const removeFrom = (arr) => {
        const i = arr.indexOf(file.rawFile);
        if (i > -1) arr.splice(i, 1);
      };
      removeFrom(this.image_files);
      removeFrom(this.image_files_all);

      this.previewImage.splice(index, 1);
      this.$emit("file-uploaded", this.image_files_all.slice());
    },
    deleteDocument(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axiosIns
            .delete(`${this.file_delete_url}`, { params: {id} })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              var index = this.previewImage.findIndex(ele => ele.id == id)
              this.previewImage.splice(index, 1);
              // 觸發父組件更新
              this.$emit("file-deleted", id);
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    /** 下載已上傳／預覽中的文件（直接下載，不在新頁打開） */
    async downloadFile(file) {
      const url = file.src;
      const name = file.name || file.file_name || 'download';
      if (!url) return;
      const isBlobOrData = url.startsWith('blob:') || url.startsWith('data:');
      if (isBlobOrData) {
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        return;
      }
      try {
        if (url.indexOf('/storage/') !== -1) {
          const pathMatch = url.match(/\/storage\/(.+)$/);
          const path = pathMatch ? pathMatch[1] : '';
          if (!path) throw new Error('無效的檔案路徑');
          const res = await axiosIns.get('serve-public-file', {
            params: { path },
            responseType: 'blob',
          });
          const blob = res.data;
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = name;
          a.rel = 'noopener noreferrer';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
          return;
        }
        const token = localStorage.getItem('accessToken');
        const res = await fetch(url, {
          method: 'GET',
          headers: token ? { Authorization: 'Bearer ' + token } : {},
          credentials: 'same-origin',
        });
        if (!res.ok) throw new Error(res.statusText);
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = name;
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      } catch (err) {
        this.$bvToast.toast('下載失敗：' + (err.message || '無法取得檔案'), {
          title: '下載失敗',
          variant: 'danger',
          autoHideDelay: 4000,
        });
      }
    },
    beforeSubmitPreview(index) {
      this.selected_file = index;
      this.$bvModal.show(`modal-image-viewer${this.custome_id}`);
    },
    // 清理 blob URLs 以防止內存洩漏
    cleanupBlobURLs() {
      this.previewImage.forEach(file => {
        if (file.blobURL) {
          URL.revokeObjectURL(file.blobURL);
        }
      });
    },
    // PDF 加載錯誤處理
    handlePdfError(file) {
      console.error('PDF 文件加載失敗:', file.name);
      this.$bvToast.toast(`PDF 文件 ${file.name} 無法顯示`, {
        title: "警告",
        autoHideDelay: 3000,
        variant: "warning",
      });
    },
    // 圖片加載錯誤處理
    handleImageError(file) {
      console.error('圖片文件加載失敗:', file.name);
    },
    // 圖片加載成功處理
    handleImageLoad() {
      // 可以在這裡添加加載成功的邏輯
    },
  },
  computed: {
    // convertSize() {
    //   var size;
    //   if (this.image_files) {
    //     size = this.image_files.size;
    //     const calc = size / (1024 * 1024);
    //     return calc > 0.1
    //       ? calc.toFixed(2) + "MB"
    //       : (calc * 1024).toFixed(2) + "KB";
    //   } else {
    //     return 0 + "KB";
    //   }
    // },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    /** 單次可上傳的檔案數上限（父層可用 limit_files 覆寫） */
    maxFiles() {
      return this.limit_files > 0 ? this.limit_files : DEFAULT_MAX_FILES;
    }
  },
  mounted() {
    /*
      Determine if drag and drop functionality is capable in the browser
    */
    this.dragAndDropCapable = this.determineDragAndDrop();
    /*
      If drag and drop capable, then we continue to bind events to our elements.
    */
    /*
        Listen to all of the drag events and bind an event listener to each
        for the fileform.
      */

    [
      "drag",
      "dragstart",
      "dragend",
      "dragover",
      "dragenter",
      "dragleave",
      "drop",
    ].forEach(
      function (evt) {
        /*
              For each event add an event listener that prevents the default action
              (opening the file in the browser) and stop the propagation of the event (so
              no other elements open the file in the browser)
          */
        this.$refs[`fileform${this.custome_id}`].addEventListener(
          evt,
          function (e) {
            e.preventDefault();
            e.stopPropagation();
          }.bind(this),
          false
        );
      }.bind(this)
    );

    /*
          Add an event listener for drop to the form
        */
    this.$refs[`fileform${this.custome_id}`].addEventListener(
      "drop",
      function (e) {
        /*
            Capture the files from the drop event and add them to our local files
            array.
          */
        // if (e.dataTransfer.files.length > 1) {
        //   this.$bvToast.toast(`Please drop only one file!`, {
        //     title: "Error",
        //     autoHideDelay: 2500,
        //     variant: "danger",
        //   });
        //   e.dataTransfer.files = [];
        //   this.image_files = null;
        // } else

        // FileList 沒有 forEach（Safari 會直接丟 TypeError），先轉成陣列。
        // 大小檢查交給 getImagePreviews 統一處理，這裡只負責收集。
        const dropped = Array.from(e.dataTransfer.files || []);
        if (dropped.length === 0) return;

        // 只放這次拖入的檔案：getImagePreviews 會把 image_files 整批
        // 併入 image_files_all，若把先前批次一起帶上會重複加入。
        this.image_files = dropped;
        this.getImagePreviews();
      }.bind(this)
    );
  },
  beforeDestroy() {
    // 組件銷毀前清理所有 blob URLs
    this.cleanupBlobURLs();
  },
  setup(props) {
    const previewImage = ref([]);

    watch(
      () => props.props_previewImage,
      (newVal) => {
        // 只接受伺服器回傳的檔案記錄。若父層誤把剛選取的 File 物件回灌進來，
        // 直接忽略，否則預覽會被換成一堆沒有圖、標示「已有文件」的空白列。
        const serverFiles = (newVal || []).filter(
          (ele) => ele && typeof ele === "object" && !(ele instanceof File)
        );

        if (serverFiles.length !== (newVal || []).length) return;

        if (serverFiles.length > 0) {
          previewImage.value = [
            ...serverFiles.map((ele) => {
              var url = ele.file_url ? ele.file_url : ele.image_url ? ele.image_url : ele.image_path;
              var path = ele.file_path ? ele.file_path : ele.image_path;
              return {
                id: ele.id,
                src:  url,
                name: ele.file_name,
                type:
                  (path && path.indexOf("pdf") > -1)
                    ? "application/pdf"
                    : "image/jpeg",
                is_exist: 1,
              };
            }),
          ];
        } else {
          previewImage.value = [];
        }
      },
      { immediate: true }
    );

    return {
      previewImage,
    };
  },
};
</script>

<style lang="scss">
.fileform {
  position: relative;
}
.removeAllButton {
  position: absolute;
  right: 1rem;
  top: 1rem;
  color: red;
}
.preview-list {
  display: block;
  margin: 0 auto;
  .preview-list-item {
    .preview-img-wrapper {
      width: 100px;
      margin-left: 5rem;
      .pdf{
        width: 80%;
      }
    }

    div.exist-item {
      position: relative;
      &:before {
        content: "已有文件";
        left: -10px;
        position: absolute;
        color: #0039ac;
      }
    }
  }
}

.fileform {
  // display: block;
  height: 250px;
  width: 100%;
  border: 1px solid #bdbdbd;
  background-color: #fff;
  text-align: center;
  border-radius: 5px;
  overflow-y: auto;

  .fa-cloud-arrow-up {
    font-size: 36px;
    color: #000;
  }

  a.file-button {
    display: inline-block;
    color: #fff;
    border-radius: 6px;
    padding: 0.75rem 5rem;
    border: 0px;
    background-color:#42459b;

    &:hover {
      color: #fff;
    }
  }
}

div.file-listing {
  margin: auto;
  padding-top: 6rem;

  img {
    height: 36px;
  }

  a.remove {
    color: #ff0000;

    &:hover {
      color: #ff0000;
    }
  }
}
</style>
